import {
  RectangleGroupIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import { useState, useEffect } from "react";
import Select from "react-select";
const cat = [
  {
    id: 10100,
    label: "Documents sans valeur commerciale",
    notAuthorized: false,
    category: 10000,
  },
  { id: 10120, label: "Journaux", notAuthorized: false, category: 10000 },
  {
    id: 10130,
    label: "Magazines, revues",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10140,
    label: "Manuels techniques",
    notAuthorized: false,
    category: 10000,
  },
  { id: 10150, label: "Livres", notAuthorized: false, category: 10000 },
  { id: 10160, label: "Passeports", notAuthorized: false, category: 10000 },
  {
    id: 10170,
    label: "Billets d'avion",
    notAuthorized: false,
    category: 10000,
  },
  { id: 10180, label: "Radiographies", notAuthorized: false, category: 10000 },
  { id: 10190, label: "Photographies", notAuthorized: false, category: 10000 },
  {
    id: 10200,
    label: "Courrier interne d'entreprise",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10210,
    label: "Propositions commerciales",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10220,
    label: "Documents publicitaires",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10230,
    label: "Catalogues, rapports annuels",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10240,
    label: "Listings informatiques",
    notAuthorized: false,
    category: 10000,
  },
  { id: 10250, label: "Plans, dessins", notAuthorized: false, category: 10000 },
  {
    id: 10260,
    label: "Documents d'impression",
    notAuthorized: false,
    category: 10000,
  },
  { id: 10280, label: "Patrons", notAuthorized: false, category: 10000 },
  {
    id: 10290,
    label: "Etiquettes, autocollants",
    notAuthorized: false,
    category: 10000,
  },
  {
    id: 10300,
    label: "Documents d'appels d'offres",
    notAuthorized: true,
    category: 10000,
  },
  {
    id: 20100,
    label: "Denrées alimentaires non périssables",
    notAuthorized: false,
    category: 20000,
  },
  {
    id: 20102,
    label: "Produits frais et périssables",
    notAuthorized: true,
    category: 20000,
  },
  {
    id: 20103,
    label: "Produits réfrigérés",
    notAuthorized: true,
    category: 20000,
  },
  {
    id: 20105,
    label: "Produits surgelés",
    notAuthorized: true,
    category: 20000,
  },
  {
    id: 20110,
    label: "Boissons non alcoolisées",
    notAuthorized: false,
    category: 20000,
  },
  {
    id: 20120,
    label: "Boissons alcoolisées",
    notAuthorized: false,
    category: 20000,
  },
  {
    id: 20130,
    label: "Plantes, fleurs, semences",
    notAuthorized: true,
    category: 20000,
  },
  {
    id: 30100,
    label: "Cosmétiques, bien-être",
    notAuthorized: false,
    category: 30000,
  },
  {
    id: 30200,
    label: "Pharmacie, médicaments",
    notAuthorized: true,
    category: 30000,
  },
  {
    id: 30300,
    label: "Chimie, droguerie, produits d'entretien",
    notAuthorized: false,
    category: 30000,
  },
  { id: 50190, label: "Tabac", notAuthorized: true, category: 30000 },
  { id: 50200, label: "Parfums", notAuthorized: true, category: 30000 },
  { id: 40100, label: "Chaussures", notAuthorized: false, category: 40000 },
  {
    id: 40110,
    label: "Tissus, vêtements neufs",
    notAuthorized: false,
    category: 40000,
  },
  {
    id: 40120,
    label: "Vêtements usagés",
    notAuthorized: false,
    category: 40000,
  },
  {
    id: 40125,
    label: "Accessoires vestimentaires, de mode",
    notAuthorized: false,
    category: 40000,
  },
  {
    id: 40130,
    label: "Cuirs, peaux, maroquinerie",
    notAuthorized: false,
    category: 40000,
  },
  {
    id: 40150,
    label: "Bijoux fantaisie",
    notAuthorized: false,
    category: 40000,
  },
  {
    id: 50160,
    label: "Bijoux, objets précieux",
    notAuthorized: true,
    category: 40000,
  },
  {
    id: 50100,
    label: "Matériel médical",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50110,
    label: "Informatique, High tech, téléphonie fixe",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50113,
    label: "Téléphonie mobile et accessoires",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50114,
    label: "Téléviseurs, écrans d'ordinateur",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50120,
    label: "Autres appareils et matériels",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50130,
    label: "Supports numériques, CD, DVD",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50140,
    label: "Pièces de rechange et accessoires (auto)",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50150,
    label: "Pièces de rechange et accessoires (autres)",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50170,
    label: "Montres, horlogerie (hors bijoux)",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50330,
    label: "Articles de camping, de pêche",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50350,
    label: "Articles de sport (hors vêtement)",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50360,
    label: "Instruments de musique et accessoires",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50380,
    label: "Matériel de chauffage, chaudronnerie",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50390,
    label: "Matériel de labo, optique, de mesure",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50395,
    label: "Matériel électrique, transfo., câbles",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50400,
    label: "Fournitures de bureau, papeterie, recharges",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50420,
    label: "Moteurs, boites de vitesse",
    notAuthorized: false,
    category: 50000,
  },
  { id: 50430, label: "Motos, scooters", notAuthorized: true, category: 50000 },
  {
    id: 50440,
    label: "Vélos, cycles sans moteur",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50450,
    label: "Outillage, outils, bricolage",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50490,
    label: "Plomberie, tubes plastiques",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 50500,
    label: "Quincaillerie, robinetterie, serrurerie",
    notAuthorized: false,
    category: 50000,
  },
  {
    id: 60100,
    label: "Mobilier d'habitation",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60102,
    label: "Mobilier de bureau",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60105,
    label: "Mobilier démonté sous emballage",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60108,
    label: "Mobilier ancien (antiquité)",
    notAuthorized: false,
    category: 60000,
  },
  { id: 60110, label: "Electroménager ", notAuthorized: true, category: 60000 },
  {
    id: 60112,
    label: "Petit électroménager, petits appareils ménagers",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60120,
    label: "Objets ou tableaux cotés, de collection, miroirs, vitres",
    notAuthorized: true,
    category: 60000,
  },
  {
    id: 60122,
    label: "Objets et tableaux courants ",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60124,
    label: "Lampes, luminaire",
    notAuthorized: false,
    category: 60000,
  },
  { id: 60126, label: "Tapis", notAuthorized: false, category: 60000 },
  {
    id: 60128,
    label: "Toiles, rideaux, draps",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60129,
    label: "Sanitaires, verres, cristallerie, vaisselle, bibelots",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 60130,
    label: "Autres objets fragiles et sculptures",
    notAuthorized: false,
    category: 60000,
  },
  {
    id: 50180,
    label: "Cadeaux, cadeaux entreprise",
    notAuthorized: false,
    category: 70000,
  },
  {
    id: 70100,
    label: "Bagages, valises, malles",
    notAuthorized: false,
    category: 70000,
  },
  {
    id: 70200,
    label: "Petit déménagement, cartons, effets personnels",
    notAuthorized: false,
    category: 70000,
  },
  {
    id: 80100,
    label: "Produits culturels : livres, jeux, CD, DVD etc",
    notAuthorized: false,
    category: 80000,
  },
  {
    id: 80200,
    label: "Appareils électroniques, Image et son etc",
    notAuthorized: false,
    category: 80000,
  },
  {
    id: 80300,
    label: "Bien-être et santé : crèmes, huiles, appareils etc",
    notAuthorized: false,
    category: 80000,
  },
  {
    id: 80400,
    label: "Puériculture, jouets, objets pour enfants etc",
    notAuthorized: false,
    category: 80000,
  },
  {
    id: 80500,
    label: "Loisirs créatifs, matériaux, art et artisanat etc",
    notAuthorized: false,
    category: 80000,
  },
];
type Props = {
  onChangeColis: (data: any) => void;
};
function Colis({ onChangeColis }: Props) {
  const [colis, setColis] = useState<any>([
    {
      name: "package 2",
      height: 1.0,
      weight: 1.0,
      width: 1.0,
      length: 1.0,
    },
  ]);
  useEffect(() => {
    onChangeColis(colis);
  }, [colis]);
  const handleChange = (e: any, index: any) => {
    const newFormData = [...colis];
    newFormData[index][e.target.name] = parseInt(e.target.value);
    setColis(newFormData);
  };

  const handleAddInputs = () => {
    setColis([
      ...colis,
      {
        name: "package 2",
        height: 1.0,
        weight: 1.0,
        width: 1.0,
        length: 1.0,
      },
    ]);
  };

  return (
    <form className=" space-y-2  ">
      {colis.map((data: any, index: any) => (
        <fieldset className="space-y-6 " key={index}>
          <div className="flex items-center justify-between py-4 ">
            <legend className="text-2xl text-gray-700 mr-4">Colis</legend>
          </div>

          <div className="flex gap-6 w-full flex-wrap">
            <div className="  ">
              <label
                htmlFor="weight"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Poids(kg)*
              </label>
              <input
                type="text"
                id="weight"
                name="weight"
                value={data.weight}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => handleChange(e, index)}
              />
            </div>
            <div className="   ">
              <label
                htmlFor="length"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Longueur(cm)*
              </label>
              <input
                type="text"
                id="length"
                name="length"
                value={data.length}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => handleChange(e, index)}
              />
            </div>
            <div className="   ">
              <label
                htmlFor="width"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Largeur(cm)*
              </label>
              <input
                type="text"
                onChange={(e) => handleChange(e, index)}
                id="width"
                name="width"
                value={data.width}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
            </div>
            <div className="   ">
              <label
                htmlFor="height"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Hauteur(cm)*
              </label>
              <input
                type="text"
                id="height"
                name="height"
                value={data.height}
                onChange={(e) => handleChange(e, index)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
            </div>
            <div className="   ">
              <label
                htmlFor="first_name"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                &nbsp;
              </label>
              {colis.length - 1 == index && (
                <button
                  onClick={handleAddInputs}
                  className="px-4 py-3 font-semibold  text-sm bg-blue-500 text-white rounded-full shadow-sm w-100"
                >
                  + <span className="md:hidden"> Ajouter colis</span>
                </button>
              )}
            </div>
          </div>
        </fieldset>
      ))}
    </form>
  );
}

export default Colis;
